import { render, staticRenderFns } from "./AccessWalletLayout.vue?vue&type=template&id=e9824d92&scoped=true&"
import script from "./AccessWalletLayout.vue?vue&type=script&lang=js&"
export * from "./AccessWalletLayout.vue?vue&type=script&lang=js&"
import style0 from "./AccessWalletLayout.vue?vue&type=style&index=0&id=e9824d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9824d92",
  null
  
)

export default component.exports